import styled from "styled-components";

const KeyVisual = () => {
  return (
    <Root>
      <Image src="/image/lp/corphurusato/kv/keyvisual.jpg" alt="はじめての企業版アニメふるさと納税" />
    </Root>
  );
};
export default KeyVisual;

const Root = styled.section`
  width: 100%;
  background-color: #9DE2F0;
  @media screen and (max-width: 960px) {
    margin-bottom: 50px;
  }
  @media screen and (min-width: 961px) {
    margin-bottom: 80px;
  }
`;

const Image = styled.img`
  display: block;
  width: 100%;
  max-width: 1460px;
  margin-right: auto;
  margin-left: auto;
`;
